import { createGqlQuery } from '@/lib/query-helper'

import { graphql } from '@/gql'

const TRACK_KEYS = {
  trackDetails: 'track-details',
  trackQuiz: 'track-quiz',
  trackList: 'track-list',
  trackLessonList: 'track-lesson-list',
  trackLessonMarkAsComplete: 'trackLessonMarkAsComplete',
  trackQuizCheckAnswer: 'track-quiz-check-answer',
  trackQuizCheckAnswerBatch: 'track-quiz-check-answer-batch',
  trackInsertJoinWebinar: 'track-insert-join-webinar',
}

const trackDetails = createGqlQuery({
  key: TRACK_KEYS.trackDetails,
  query: graphql(`
    query TrackDetails($trackId: String!, $myTrack: Boolean!) {
      getDetailTrack(track_id: $trackId, my_track: $myTrack) {
        id
        title
        banner_icon_url
        description_content
        difficulty
        onboarding_category
        short_description_content
        overview
        img
        price
        discount
        is_free
        tag
        webinar_link
        name_of_trainer
        duration
        course_type
        rating
        total_sell
        total_price
        total_discount
        percentage_progress
        self_exercise_count
        user_project_count
        purchased
        solved_lesson_count
        total_lesson_count
        lesson_video_count
        last_chapter_activity
        last_tutorial_activity
        has_rating
        track_category {
          id
          category
        }
        trainers {
          image
          name
          job
          description
        }
        quiz {
          question_count
          user_score
          user_status
          fr_pmo {
            redeem_code
            sequence
            is_verify
            ready_to_fr
          }
        }
        is_already_project
        is_already_quiz
      }
      getListTutorialFromDetailTrack(track_id: $trackId, my_track: $myTrack) {
        tutorials {
          id
          track_id
          title
          description
          type
          video_duration
          mid_exam
          has_self_exercise
          has_already_submit_self_exercise
          self_exercise
          self_exercise_deadline
          self_exercise_attachment
          self_exercise_score
          self_exercise_feedback
          is_feedback
          chapters {
            id
            tutorial_id
            title
            status
            lesson_video_count
            total_lesson_count
            solved_lesson_count
            chapter_type
            duration_quiz_countdown
            guide
            attempt
            quiz_score
          }
          chapter_km {
            id
            title
            chapter_type
            lesson_video_count
            total_lesson_count
            solved_lesson_count
            quiz_status
            total_quiz_count
            quiz_score
            status
            attempt
            webinar {
              id
              done
              url_join
              start_time_webinar
              end_time_webinar
              attend
              valid_at
              confirm
            }
          }
          quiz {
            question_count
            user_score
            user_status
          }
        }
      }
    }
  `),
})

const trackQuiz = createGqlQuery({
  key: TRACK_KEYS.trackQuiz,
  query: graphql(`
    query TrackQuiz($chapterId: String!) {
      getQuizChapterByChapterID(chapter_id: $chapterId) {
        expired_at
        quiz_chapter {
          id
          question
          chapter_id
          package
          media
          quiz_type
          quiz_chapter_options {
            id
            option
            quiz_chapter_id
          }
          chapter {
            id
            title
            duration_quiz_countdown
            guide
          }
          tutorial {
            id
            title
          }
          track {
            id
          }
        }
      }
    }
  `),
})

const trackQuizCheckAnswer = createGqlQuery({
  key: TRACK_KEYS.trackQuizCheckAnswer,
  query: graphql(`
    mutation TrackQuizCheckAnswer($req: AnswerSingleQuizChapterRequest!) {
      answerQuizChapter(input: $req) {
        is_correct
        explanation
      }
    }
  `),
})

const trackQuizCheckAnswerBatch = createGqlQuery({
  key: TRACK_KEYS.trackQuizCheckAnswerBatch,
  query: graphql(`
    mutation TrackQuizCheckAnswerBatch($req: AnswerListQuizChapterRequest!) {
      answerListQuizChapter(input: $req) {
        condition
        score
        total_benar
        total_salah
        min_score
      }
    }
  `),
})

const trackList = createGqlQuery({
  key: TRACK_KEYS.trackList,
  query: graphql(`
    query GetTracksWithPagination(
      $filterMyClass: FilterMyClass!
      $myClass: Boolean!
    ) {
      getTracksWithPagination(
        course_type: Yes
        current_page: 1
        filter_my_class: $filterMyClass
        my_class: $myClass
        get_certificate: false
        search: ""
        sortBy: Newest
        page_size: 10
      ) {
        total_page
        previous_page
        next_page
        data {
          id
          title
          iconURL
          img
          bannerIconURL
          price
          discount
          isFree
          tag
          courseType
          rating
          total_sell
          total_price
          track_category {
            id
            category
          }
          total_discount
          percentage_progress
        }
      }
    }
  `),
})

const trackLessonList = createGqlQuery({
  key: TRACK_KEYS.trackLessonList,
  query: graphql(`
    query TrackLessonList($chapterId: String!) {
      listLessonFromDetailChapter(chapter_id: $chapterId) {
        lessons {
          id
          chapter_id
          sorting
          title
          image_url
          content
          lesson_content
          type
          lesson_type
          video_duration
          created_at
          updated_at
          solved_lesson {
            id
            completed_at
          }
        }
        last_lesson_index_activity
      }
    }
  `),
})

const trackLessonMarkAsComplete = createGqlQuery({
  key: TRACK_KEYS.trackLessonMarkAsComplete,
  query: graphql(`
    mutation TrackLessonMarkAsComplete(
      $chapterId: String!
      $lessonId: String!
      $completedAt: String!
      $startedAt: String!
    ) {
      progressLesson(
        input: {
          chapter_id: $chapterId
          lesson_id: $lessonId
          completed_at: $completedAt
          started_at: $startedAt
        }
      ) {
        id
        user_id
        lesson_id
        chapter_id
        track_id
        started_at
        completed_at
        tries
        created_at
        updated_at
        tmp
      }
    }
  `),
})

const trackInsertJoinWebinar = createGqlQuery({
  key: TRACK_KEYS.trackInsertJoinWebinar,
  query: graphql(`
    mutation InsertJoinWebinar($req: InsertJoinWebinarRequest!) {
      insertJoinWebinar(input: $req) {
        success
      }
    }
  `),
})

const trackTryOutQuizChapterScore = createGqlQuery({
  key: 'track-quiz-chapter-score',
  query: graphql(`
    query GetTryOutQuizChapterScore($tutorialId: String!) {
      getTryOutQuizChapterScore(tutorial_id: $tutorialId) {
        score
      }
    }
  `),
})

const trackSubmitSelfExercise = createGqlQuery({
  key: 'track-submit-self-exercise',
  query: graphql(`
    mutation SubmitTpm($req: SubmitTPMRequest!) {
      submitTPM(input: $req) {
        id
        user_id
        tutorial_id
        attachment
        created_at
        updated_at
      }
    }
  `),
})

export {
  trackDetails,
  trackQuiz,
  trackList,
  trackQuizCheckAnswer,
  trackQuizCheckAnswerBatch,
  trackLessonList,
  trackLessonMarkAsComplete,
  trackInsertJoinWebinar,
  trackTryOutQuizChapterScore,
  trackSubmitSelfExercise,
}
